/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_Image_Per_TokenInputs */



/**
* | output |
* | --- |
* | "Billed by the tokens each request uses. Prices per 1 million tokens." |
*
* @param {Model_Pricing_Image_Per_TokenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_image_per_token = /** @type {((inputs?: Model_Pricing_Image_Per_TokenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_Image_Per_TokenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgerechnet nach den Tokens, die jede Anfrage verbraucht. Preise pro 1 Million Tokens.")
	return /** @type {LocalizedString} */ ("Billed by the tokens each request uses. Prices per 1 million tokens.")
});